import styled from "styled-components";

interface IProps {
  open: boolean;
  relooad?:string;
}


export const Overlay = styled.div<IProps>`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 999999;
  background: rgba(0, 0, 0, .7);
  display: ${props => props.open ? 'block' : 'none'};
`;


export const ContentWrapper = styled.div<IProps>`
  top: 87px;
  opacity: 1;
  width: 560px;
  height: 500px;
  z-index: 9999999;
  position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);


  background: #FFFFFF 0% 0% no-repeat padding-box;
  display: ${props => props.open ? 'block' : 'none'};

  @media (max-width: 820px) {
    right: 80px;
    height: fit-content;
  }

  @media (max-width: 600px) {
    width: 80%;
  }
`;


export const Container = styled.div`
display: flex ;
height: auto ;
width:  auto;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
background-color: white;
padding: 40px;
justify-content:  flex-start;
min-width: 975px;
.containerMapTwo{
  margin-left: 2%;
}
.boxMap{
  height: 100% ;
  width: 500px ;
} 
.leaflet-container{
  background-color: transparent;
  }
  .popupCustom{
    background-color: red;
  }
  .custom   .leaflet-popup-content-wrapper, .leaflet-popup-tip{
    box-shadow: none;
    border-radius: none;
  }
  .custom .leaflet-popup-content-wrapper {
      color: #ffffff;
      background-color: transparent;
  }
  .custom .leaflet-popup-content {
    margin: 0;
  }
  .custom {
    p:first-child{
      color: #6C6C6C;
      font-size: 10px;
      margin-bottom: 5px;
    }
    p {
    font-size: 12px;
    margin: 0;
    color: #161615;
    margin-bottom: 2px;
  }
  }
  
  
`

export const CollwnSelect = styled.div`



`

export const Header = styled.div`

display:flex;
max-height: 40px;
min-height: 40px;
align-items: center ;
margin-bottom: 5% ;
img{
  width: 34px;
  height: 34px;
  margin-right: 8px;
}
p{
  letter-spacing: 0px;
  color: #161615;
  opacity: 1;
  font-weight: 800;
  width: 160px;
  margin:0 ;
  font-size: 18px;
  line-height: 20px;
}
@media (max-width: 820px) {
  display: none;
}
`